import { Platform, StyleSheet } from 'react-native';
import { spacing, window } from '../../../theme/tokens';

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.medium,
    paddingHorizontal: spacing.medium,
    width: Platform.OS === 'web' ? window.width / 2 : undefined,
  },
});

export default styles;
